import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { kasirNav } from '@/lib/navConfig';
import ProductsManager from '@/components/products/ProductsManager';

export default function KasirProducts() {
  return <AppShell nav={kasirNav} title="Barang"><ProductsManager /></AppShell>;
}
